<template>
    <div class="pulse-container">
        <div class="pulse"></div>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'Pulsate',
};
</script>

<style scoped>
.pulse-container {
    position: absolute;
}

.pulse {
    border: 3px solid var(--primary);
    border-radius: inherit;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    animation: pulsate 1s ease-out;
    animation-iteration-count: infinite;
    opacity: 0;
}
@-webkit-keyframes pulsate {
    0% {
        transform: scale(0.6, 0.6);
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        transform: scale(1.4, 1.4);
        opacity: 0;
    }
}
</style>
